import {NotificationBanner as UINotificationBanner} from '@commercial-website/ui'
import React from 'react'

import RichText, {hasRichText} from '@/components/rich-text'
import type {Props as RichTextProps} from '@/components/rich-text'

type NotificationBannerProps = {
    content: RichTextProps['content']
}

/**
 * Site notification banner.
 *
 * Wraps the CMS-agnostic `@commercial-website/ui` NotificationBanner and feeds it
 * Prismic rich text via the site's RichText renderer. Renders nothing when there
 * is no content, so an unset field never shows an empty bar.
 */
export const NotificationBanner = ({content}: NotificationBannerProps) => {
    if (!hasRichText(content)) {
        return null
    }

    return (
        <UINotificationBanner>
            <RichText content={content} $variant="paragraph-base" $center />
        </UINotificationBanner>
    )
}
